import './ImageRadioPicker.css';
import * as React from "react";
import PropTypes from "prop-types";
import infoIcon from './../images/template/info.png'
import {useState} from "react";

const CHILD_PROP = "value";
const CHILD_TEXT_PROP = "text";

export default function ImageRadioPicker(props) {
    const smallScreen = props.small || props.medium;

    const [hover, setHover] = useState(false);
    const [hint, setHint] = useState(false);
    const [cachedText, setCachedText] = useState("");

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            props.onSelect(props.value)
        }
    }

    const isCurrent = () => {
        if (props.child) {
            return props.current && props.current[CHILD_PROP] === props.value[CHILD_PROP]
        } else {
            return props.current === props.value;
        }
    }

    const getAlt = () => {
        if (props.child) {
            return props.value[CHILD_PROP];
        } else {
            return props.value;
        }
    }

    if (isCurrent() && props.child && props.current[CHILD_TEXT_PROP] !== cachedText) {
        setCachedText(props.current[CHILD_TEXT_PROP]);
    }

    return (
        <label
            onPointerEnter={() => setHover(true)}
            onPointerLeave={() => setHover(false)}
            tabIndex="0"
            className={"radio-select " + (props.medium ? "medium" : (props.small ? "small" : ""))}
            onClick={() => {
                if (!isCurrent()) {
                    if (props.child) {
                        props.onSelect({...props.value, text: cachedText})
                    } else {
                        props.onSelect(props.value)
                    }
                }
            }}
            title={getAlt()}
            onKeyPress={handleKeyPress}>
            <img className={isCurrent() ? "checked noselect" : "noselect"}
                 src={props.image}
                 alt={getAlt()}
            />
            {props.child && !smallScreen && isCurrent() ? <textarea
                placeholder={"Omschrijf hier uw gewenste situatie"}
                onChange={(e) => {
                    props.onSelect({...props.current, text: e.currentTarget.value});
                    setCachedText(e.currentTarget.value);
                }} className="other"
                value={props.current[CHILD_TEXT_PROP]}/> : null}
            {props.hintText != null && !smallScreen && hint
                ? <div className="hint">{props.hintText}</div>
                : null}
            {props.hintText != null && !smallScreen && hover
                ? <img
                    onPointerEnter={() => setHint(true)}
                    onPointerLeave={() => setHint(false)}
                    className={"hint-icon " + (hint ? "transparent" : "")} src={infoIcon} alt="info"/>
                : null}
        </label>
    );
}

ImageRadioPicker.propTypes = {
    onSelect: PropTypes.func.isRequired,
    current: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    value: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
    image: PropTypes.string.isRequired,
    hintText: PropTypes.string,
    child: PropTypes.bool,
    small: PropTypes.bool,
    medium: PropTypes.bool,
}